import useAuthService from './useAuthService';
import { useMemo } from 'react';

export const useUserData = () => {
  const { user } = useAuthService();

  return useMemo(() => {
    return {
      name: user?.name || '',
      lastName: user?.lastName || '',
      email: user?.email || '',
    };
  }, [user]);
};
